import React, { useCallback, useState } from 'react';

import { AsaphButton } from '@/components/shared/Button';
import { EditInput } from '@/components/shared/Inputs';

import styles from './EditTeamName.module.scss';

export interface EditTeamNameProps {
	loading?: boolean;
	name?: string;
	onSave: (name: string) => void;
}

export const EditTeamName: React.FC<EditTeamNameProps> = ({
	name,
	onSave,
	loading = false,
}) => {
	const initialTeamName = name;
	const [teamName, setTeamName] = useState<string>(initialTeamName ?? '');

	const save = useCallback(() => onSave(teamName), [teamName, onSave]);

	return (
		<>
			<div className={styles['edit-team']}>
				<div className="vsb-40" />
				<EditInput
					id="team-name"
					autoComplete="off"
					name="team-name"
					type="text"
					disabled={loading}
					value={teamName}
					onChange={(event) => setTeamName(event.target.value)}
					error={teamName.length === 0}
					helperText="This could be your church name or a nickname.
				It's how your team will appear on Asaph."
					fullWidth
				/>
			</div>
			<div className={styles['edit-team__action']}>
				<AsaphButton
					color="blue"
					label="Save"
					onClick={save}
					disabled={
						teamName.length === 0 ||
						teamName === initialTeamName ||
						loading
					}
					fullWidth
				/>
			</div>
		</>
	);
};
